import {
    ProductConfigurableAttributeDropdownContainer as SourceProductConfigurableAttributeDropdownContainer
} from 'SourceComponent/ProductConfigurableAttributeDropdown/ProductConfigurableAttributeDropdown.container';

/** @namespace Elganso/Component/ProductConfigurableAttributeDropdown/Container */
export class ProductConfigurableAttributeDropdownContainer extends SourceProductConfigurableAttributeDropdownContainer {
    componentDidMount() {
        const {
            updateConfigurableVariant,
            option: {
                attribute_code
            }
        } = this.props;

        const opciones = this._getSelectOptions();

        if (opciones.length > 0) {
            const {
                isAvailable,
                value
            } = opciones[0];

            if (attribute_code === 'precio_tarjeta_regalo' && isAvailable) {
                this.setState({ opcion_seleccionada: value });
                updateConfigurableVariant(attribute_code, value, true);
            }
        }
    }

    state = {
        opcion_seleccionada: null
    };

    containerProps() {
        const { option: { attribute_code, attribute_label }, isUnselected, product } = this.props;
        const { opcion_seleccionada } = this.state;

        return {
            selectValue: this._getSelectValue(),
            selectOptions: this._getSelectOptions(),
            selectName: attribute_code,
            selectLabel: attribute_label,
            isUnselected,
            product,
            opcion_seleccionada
        };
    }

    onChange(value) {
        const {
            updateConfigurableVariant,
            option: { attribute_code }
        } = this.props;

        updateConfigurableVariant(attribute_code, value, true);
    }

    _getSelectOptions() {
        const {
            option: {
                attribute_options,
                attribute_code
            },
            getIsConfigurableAttributeAvailable
        } = this.props;

        if (!attribute_options) {
            // eslint-disable-next-line no-console
            console.warn(`Please make sure "${ attribute_code }" is visible on Storefront.`);

            return [];
        }

        return Object.values(attribute_options)
            .reduce((acc, option) => {
                const { value } = option;

                const isAvailable = getIsConfigurableAttributeAvailable({
                    attribute_code,
                    attribute_value: value
                });

                return [...acc, {
                    ...option,
                    id: value,
                    isAvailable
                }];
            }, []);
    }
}

export default ProductConfigurableAttributeDropdownContainer;
